import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1048"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5.652 3.698c-.126 0-.231.044-.315.133s-.126.198-.126.329.042.24.126.329.189.133.315.133.23-.044.315-.133a.46.46 0 0 0 .127-.332.45.45 0 0 0-.126-.329.423.423 0 0 0-.316-.13z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M14.201 8.917h-2.272V1.456a.475.475 0 0 0-.475-.475H4.403a.475.475 0 0 0-.475.475v7.461H1.784a.303.303 0 0 0-.2.532l6.253 5.475a.237.237 0 0 0 .312 0l6.253-5.475a.304.304 0 0 0-.201-.532zM5.664 5.01a.893.893 0 0 1-.64-.249.81.81 0 0 1-.26-.608c0-.239.087-.443.261-.612a.868.868 0 0 1 .628-.253c.26 0 .473.08.64.242a.819.819 0 0 1 .249.616.836.836 0 0 1-.249.62.868.868 0 0 1-.629.244zm3.612 3.225c.506-.133.823-.512.958-.706l.474.505a2.624 2.624 0 0 1-.868.758c-.473.259-.911.246-1.092.242-.194-.005-1.03-.024-1.65-.664-.626-.647-.653-1.455-.653-1.744 0-.648.24-1.205.668-1.67.097-.106.357-.353.722-.521.607-.28 1.17-.18 1.327-.15.145.028.572.125.994.465.244.197.461.464.555.611l-.484.521c-.11-.183-.487-.632-1.042-.774-.779-.199-1.932.258-1.943 1.548-.01 1.269 1.104 1.824 2.034 1.579z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }